export const SIDEBAR_ITEMS = {
  cards: {
    user_type: "both",
    title: "Cards",
    router: "/dashboard/cards",
    class: "fa-fw fas fa-address-card",
    aria_hidden: "true",
    is_hidden: true
  },
  passes: {
    user_type: "both",
    title: "Passes",
    router: "/dashboard/passes",
    class: "fa-fw fas fa-id-badge",
    aria_hidden: "true",
    is_hidden: false
  },
  profile: {
    user_type: "both",
    title: "Profile",
    router: "/dashboard/profile",
    class: "fa-fw fas fa-user-circle",
    aria_hidden: "true",
    is_hidden: false
  },
  roles: {
    user_type: "business",
    title: "Roles",
    router: "/dashboard/roles",
    class: "fa-fw fas fa-user-circle",
    aria_hidden: "true",
    is_hidden: false
  },
  agreements: {
    user_type: "business",
    title: "Agreements",
    router: "/dashboard/agreements",
    class: "fa-fw fas fa-file-alt",
    aria_hidden: "true",
    is_hidden: false
  },
  verify_account: {
    user_type: "individual",
    title: "Verify Account",
    router: "/dashboard/verify-account",
    class: "fa-fw fas fa-file-alt",
    aria_hidden: "true",
    is_hidden: true
  },
  settings: {
    user_type: "both",
    title: "Account Settings",
    router: "/dashboard/settings",
    class: "fa-fw fas fa-cog",
    aria_hidden: "true",
    is_hidden: true
  }
}



// WEBPACK FOOTER //
// ./src/api/constants/Sidebar.js